<template>
    <router-view></router-view>

</template>
<script>
import languages from '@/common/language'
export default {
    mixins: [],
    name: 'app',
    components: {},
    data(){
        return {

        }
    },
    beforeCreate(){
        // new vConsole();
    },
    created(){
        let url=location.search||location.hash
        let search=url.split('?')[1]
        window.urlHash={}
        if (search) {

            let arr=search.split('&');
            for(let item of arr){
                let key=item.split('=')[0]
                let value=item.split('=')[1]
                window.urlHash[key]=value;
            }
        }
        let lang = 'EN'
        let languageStr=window.urlHash.language||window.localStorage.getItem('lang')||lang;
        this.$store.commit('setLanguage', languages[languageStr]);
        this.$store.commit('setLanguage', {currentLanguage:languageStr});
    },
    mounted(){
        this.$nextTick(()=>{
            jQuery(document).ready(function( $ ) {

                // Back to top button
                $(window).scroll(function() {
                    if ($(this).scrollTop() > 100) {
                        $('.back-to-top').fadeIn('slow');
                    } else {
                        $('.back-to-top').fadeOut('slow');
                    }
                });
                $('.back-to-top').click(function(){
                    $('html, body').animate({scrollTop : 0},1500, 'easeInOutExpo');
                    return false;
                });


                // Intro background carousel
                $("#intro-carousel").owlCarousel({
                    autoplay: true,
                    dots: false,
                    loop: true,
                    animateOut: 'fadeOut',
                    items: 1
                });

                // Initiate the wowjs animation library
                new window.WOW().init();





                // Porfolio - uses the magnific popup jQuery plugin
                $('.portfolio-popup').magnificPopup({
                    type: 'image',
                    removalDelay: 300,
                    mainClass: 'mfp-fade',
                    gallery: {
                        enabled: true
                    },
                    zoom: {
                        enabled: true,
                        duration: 300,
                        easing: 'ease-in-out',
                        opener: function(openerElement) {
                            return openerElement.is('img') ? openerElement : openerElement.find('img');
                        }
                    }
                });

                // Testimonials carousel (uses the Owl Carousel library)
                $(".testimonials-carousel").owlCarousel({
                    autoplay: true,
                    dots: true,
                    loop: true,
                    responsive: { 0: { items: 1 }, 768: { items: 2 }, 900: { items: 3 } }
                });

                // Clients carousel (uses the Owl Carousel library)
                $(".clients-carousel").owlCarousel({
                    autoplay: true,
                    dots: true,
                    loop: true,
                    responsive: { 0: { items: 2 }, 768: { items: 4 }, 900: { items: 6 }
                    }
                });


            });

        })
    },
    methods: {
    }
}

</script>
<style lang="scss">
body,html {
  background: #fff;
  color: #444;
  font-family: "Open Sans", sans-serif;
  height: 100%;
  width: 100%;
}

a {
  color: #007bff;
  transition: 0.5s;
}

a:hover, a:active, a:focus {
  color: #51d8af;
  outline: none;
  text-decoration: none;
}

p {
  padding: 0;
  margin: 0 0 30px 0;
}

h1, h2, h3, h4, h5, h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  margin: 0 0 20px 0;
  padding: 0;
}

/* Back to top button */
.back-to-top {
  position: fixed;
  display: none;
  background: #007bff;
  color: #fff;
  padding: 6px 12px 9px 12px;
  font-size: 16px;
  border-radius: 2px;
  right: 15px;
  bottom: 15px;
  transition: background 0.5s;
}

@media (max-width: 768px) {
  .back-to-top {
    bottom: 15px;
  }
}

.back-to-top:focus {
  background: #007bff;
  color: #fff;
  outline: none;
}

.back-to-top:hover {
  background: #0c2e8a;
  color: #fff;
}

</style>
